export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_17.1dcaa31c.mp4";